<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <popup-edit-allergy ref="popupEditAllergy" type="Stock" />
    <div class="flex justify-between">
      <p>These can be added to a order to inform about potential allergies.</p>
      <div class="flex justify-end">
        <vs-button
          icon="add"
          @click="$refs.popupEditAllergy.show()"
          type="relief"
          color="primary"
          class="mr-3"
          >Add allergy</vs-button
        >
      </div>
    </div>
    <!-- table -->
    <div class="data-list-list-view">
      <vs-table ref="table" class="mt-4" :max-items="50" :data="allergies">
        <template slot="thead">
          <vs-th sort-key="name">Allergy</vs-th>
          <vs-th sort-key="createdAt">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td :data="tr.name">
                {{ tr.name }}
              </vs-td>

              <vs-td>
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click.stop="confirmDelete(tr.allergyId.id)"
                />
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click.stop="$refs.popupEditAllergy.show(tr)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <!-- Save & Remove Button -->
    <vs-row>
      <vs-button id="save-button" @click="saveChanges" class="mt-4"
        >Save Changes</vs-button
      >
    </vs-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import popupEditAllergy from "./PopupEditAllergy.vue";

export default {
  components: { popupEditAllergy },
  data() {
    return {
      isLoading: true,
      toDelete: null,
      ProductIcon,
    };
  },
  methods: {
    confirmDelete(id) {
      this.toDelete = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Delete allergy",
        text: "Are you sure you want to delete this allergy?",
        accept: this.deleteAllergy,
      });
    },
    async saveChanges() {
      this.$vs.loading();
      await this.$store.dispatch("pos/countrySettings/updateCountrySettings");
      this.$vs.loading.close();
    },
    deleteAllergy() {
      this.$store.commit(
        "pos/countrySettings/deleteAllergy",
        this.toDelete
      );
      this.toDelete = null;
    },
    async onClickCreateNew() {
      this.$refs.popupEditAllergy.show();
    },
  },
  computed: {
    ...mapGetters({
      allergies: "pos/countrySettings/allergies",
    }),
  },

  async created() {
    this.isLoading = true;
    await Promise.all([
      this.$store.dispatch("pos/countrySettings/getStockWasteReasons"),
    ]);
    this.isLoading = false;
  },
};
</script>